import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
interface Props {
  open: boolean;
  token: string;
  closeHandler: () => void;
}

export default function DashboardKioskLinkDialog({ open, token, closeHandler }: Props) {
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(token);
      setCopySuccess(true);

      setTimeout(() => {
        setCopySuccess(false);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy text: ', error);
    }
  };

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Dashboard Kiosk Link</DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <TextField
            value={token}
            variant="outlined"
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
          <Tooltip title={copySuccess ? 'Copied!' : 'Copy to clipboard'} arrow>
            <IconButton onClick={handleCopy} aria-label="Copy to clipboard">
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={closeHandler}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
